import React from 'react';

import './style.css';

const A = ({
  href,
  onClick,
  children,
  newWindow,
  className="",
  style={},
  download=false,
}) => {
  // NOTE: provide either 'href' or 'onClick' here, but not both
  if(href) {
    const openNewWindow = newWindow || href.startsWith('http');
    // eslint-disable-next-line react/jsx-no-target-blank
    return (<a
        className={`A-a ${className}`}
        style={style}
        href={href}
        target={openNewWindow ? '_blank' : undefined}
        rel={openNewWindow ? 'nofollow noopener noreferrer' : 'nofollow'}
        download={download}
      >{ children }</a>
    );
  }

  return (
    <button
      type="button"
      className={`A-button ${className}`}
      onClick={onClick}
    >{ children }</button>
  );
}

export default A;
